/**
 * API base URL rules, mirroring apps/app-frontend:
 *   1. localhost → REACT_APP_API_URL when set, else http://localhost:3001
 *      (dev fallback).
 *   2. any real host → https://<current hostname>/backend — ALWAYS
 *      same-origin, through the SAME nginx `/backend/` → app-backend
 *      passthrough app-frontend uses. A baked absolute REACT_APP_API_URL is
 *      deliberately IGNORED here: honoring it pinned every deployment's
 *      browser calls to one hardcoded subdomain (cross-origin), and traffic
 *      must always enter via the current host's own LB path.
 */
import axios from 'axios';
import { loadSession } from '../utils/session';

export const buildApiBaseUrl = (hostname, configured) => {
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return configured || 'http://localhost:3001';
  }
  return `https://${hostname}/backend`;
};

export const getApiBaseUrl = () => buildApiBaseUrl(
  window.location.hostname,
  process.env.REACT_APP_API_URL,
);

export const api = axios.create();

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;
  const sessionToken = loadSession()?.sessionToken;
  if (sessionToken) {
    config.headers.Authorization = `Bearer ${sessionToken}`;
  }
  if (!String(config.url).startsWith('http')) {
    config.url = `${getApiBaseUrl()}${String(config.url).startsWith('/') ? config.url : `/${config.url}`}`;
  }
  return config;
});
